import React, { useMemo, useState } from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';

function numOrNull(v) {
  if (v === '' || v == null) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export default function OtherPaymentTab() {
  const [amountTry, setAmountTry] = useState('');
  const [desc, setDesc] = useState('');

  const canSave = useMemo(() => {
    const a = numOrNull(amountTry);
    if (a == null || a <= 0) return false;
    if (!String(desc || '').trim()) return false;
    return true;
  }, [amountTry, desc]);

  return (
    <MDBox sx={{ display: 'grid', gap: 1 }}>
      <MDInput
        type="number"
        label="Tutar (₺)"
        value={amountTry}
        onChange={(e) => setAmountTry(e.target.value)}
        fullWidth
      />
      <MDInput
        label="Açıklama"
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
        fullWidth
        multiline
        rows={2}
      />

      <MDTypography variant="caption" sx={{ opacity: 0.75 }}>
        Örn: “Kayıp ekipman”, “Özel ders”, “Ürün satışı” vb.
      </MDTypography>

      <MDButton
        variant="gradient"
        color="success"
        disabled={!canSave}
        fullWidth
        onClick={() => {
          // TODO: other payment create endpoint
          alert(`Diğer ödeme: ₺${amountTry} • ${desc}`);
        }}
        sx={{ borderRadius: '16px', textTransform: 'none', fontWeight: 900, height: 44 }}
      >
        Kaydet
      </MDButton>
    </MDBox>
  );
}
